module.exports = __webpack_public_path__ + "img/logo.0544ae88.png";